module.exports = __webpack_public_path__ + "5ce63ab82379774399f5066c6b8d1211.png";